import { useEffect, useState } from "react";

/**
 * Small playful bar that slides in when the browser loses its connection.
 * Purely client-side; uses the browser's online/offline events.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    update();
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-[60] flex items-center justify-center gap-2 bg-primary px-4 py-2.5 text-center text-sm font-semibold text-primary-foreground shadow-[0_-6px_20px_-8px_rgba(0,0,0,0.4)] animate-pop-in"
    >
      <span className="animate-bob text-base">🐼</span>
      <span>Είστε εκτός σύνδεσης — ο MrPanda περιμένει να επανέλθει το ίντερνετ 🎋</span>
    </div>
  );
}
